// extracted by mini-css-extract-plugin
export default {"committeeMeetings":"committee-meeting-documents_committeeMeetings__Ich4S"};